import React from "react";

class MessageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[MESSAGE-CRASH]", {
      error,
      info,
      context: this.props.context || {}
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16 }}>
          Erro ao renderizar mensagens. Recarregue o ticket.
        </div>
      );
    }

    return this.props.children;
  }
}

export default MessageErrorBoundary;
